module.exports = "agm-map{height:70vh}\n"